/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetSocialConnectionsConnectionsForStationQueryResponse, GetSocialConnectionsConnectionsForStationPathParams } from "../models/GetSocialConnectionsConnectionsForStation";

export function getGetSocialConnectionsConnectionsForStationUrl(station: GetSocialConnectionsConnectionsForStationPathParams["station"]) {
  const res = { method: 'GET', url: `/social-connections/${station}` as const }
  return res
}

/**
 * @summary Get all connection states for a station
 * {@link /social-connections/:station}
 */
export async function getSocialConnectionsConnectionsForStation(station: GetSocialConnectionsConnectionsForStationPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetSocialConnectionsConnectionsForStationUrl(station).url.toString(), ... requestConfig })
  return res.data
}